/**
 * Workspace navigation configuration.
 *
 * Consumed by WorkspaceLayout for both desktop sidebar
 * and mobile slide-over panel.
 */

export interface WorkspaceNavItem {
  label: string;
  path: string;
  description: string;
}

export const WORKSPACE_NAV_ITEMS: WorkspaceNavItem[] = [
  { label: 'Overview', path: '/workspace', description: 'Your workspace summary' },
  { label: 'My Profile', path: '/workspace/profile', description: 'View and edit your creator profile' },
  { label: 'My Application', path: '/workspace/application', description: 'Resume or review your application' },
  { label: 'Application Status', path: '/workspace/status', description: 'Track your application progress' },
  { label: 'Account', path: '/workspace/account', description: 'Account settings and security' },
];
